import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PasswordRecovery from '../../../components/Auth/PasswordRecovery/PasswordRecovery';
import { nbsApiForgotPassword } from '../../../store/actions/forgotPassword';
import PropsRoute from '../../../hoc/PropsRoute/PropsRoute';
import Auxi from '../../../hoc/Auxi/Auxi';
import IndexPage from '../../IndexPage/IndexPage';
import { gtmTrack } from '../../../assets/helpers/GAHelper';

class PasswordRecoveryContainer extends Component {
  state = {
    showAlert: false,
    errorMessage: null,
    showSpinner: false,
    isRecoveryPasswordSent: false,
  };

  componentDidUpdate(prevProps) {
    // console.log('componentDidUpdate password recovery container', prevProps);

    if (this.props.forgotPassword.error !== null) {
      // Handle Forgot Password Failure
      if (
        this.props.forgotPassword.status === 'fail' &&
        prevProps.forgotPassword.status !== 'fail'
      ) {
        this.setState({
          errorMessage: this.props.forgotPassword.error.error,
          showAlert: true,
        });
      }

      // Handle Forgot Password Success
      if (
        this.props.forgotPassword.status === 'success' &&
        prevProps.forgotPassword.status !== 'success'
      ) {
        this.setState({
          showAlert: null,
          errorMessage: null,
          showSpinner: null,
          isRecoveryPasswordSent: true,
        });

        gtmTrack({
          event: 'reset_password',
        });
      }
    }
  }

  nbsForgotPassword = (emailAddress) => {
    this.props.nbsApiForgotPassword(emailAddress);
  };
  goBack = () => {
    this.props.history.goBack();
  };
  toggleAlertError = (errorMessage) => {
    this.setState({ showAlert: !this.state.showAlert, errorMessage });
  };

  render() {
    return (
      <Auxi>
        {this.props.isLandscape ? (
          <PropsRoute
            isLandscape={this.props.isLandscape}
            component={IndexPage}
          />
        ) : null}
        <PasswordRecovery
          isLandscape={this.props.isLandscape}
          nbsForgotPassword={this.props.nbsApiForgotPassword}
          showSpinner={this.props.forgotPassword.isFetching}
          showErrorAlert={this.state.showAlert}
          toggleAlertError={this.toggleAlertError}
          goBack={this.goBack}
          isRecoveryPasswordSent={this.state.isRecoveryPasswordSent}
          emailErrorMessage={this.state.errorMessage}
        />
      </Auxi>
    );
  }
}
function mapStateToProps(state) {
  return {
    forgotPassword: state.forgotPassword,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      nbsApiForgotPassword,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordRecoveryContainer);
